import React from 'react';
import './CanaanBanner.css'; 
import CanaanProductImage1 from '../../../../assets/Canaan/Canaan-Product3.jpg'; 

const CanaanBannerFullScreenImageProduct = () => {
  return (
     <img
      src={CanaanProductImage1} 
      alt="FullScreenImage"
      className="Canaan-Banner-full-screen-image"
    />
   );
};

export default CanaanBannerFullScreenImageProduct;
